@if (currentPromotions.ProductLevelPromotion) {
	<div class="product-promotion-container">
		@for (key of currentPromotions | keys; track trackByFn($index, key)) {
			@if (!linkHref()) {
				<common-side-nav class="common-side-nav" [side]="'right'" [addFlexBox]="addFlexBox()" [isSidePanelToggled]="isSidePanelToggled" [modalName]="heading" tabindex="0" (panelEvent)="panelOpened($event)">
					<div id="promoPanelHeader" ngProjectAs="myCustomHeader">
						{{ heading }}
					</div>
					<div id="promoPanelBody" ngProjectAs="myCustomBody" [innerHTML]="currentPromotions[key?.key]?.longDesc | dcsgSanitizeHtml" class="hmf-p-md-l hmf-p-s"></div>
					<div [class]="textContainerClassList()" ngProjectAs="myPanelCover">
						<span class="promotion-description-text hmf-subheader-m label-sale">{{ key?.value?.pdpDesc }}</span>
					</div>
				</common-side-nav>
			} @else {
				<div [class]="textContainerClassList()">
					<a class="promotion-description-text hmf-subheader-m label-sale" [href]="linkHref()">{{ key?.value?.pdpDesc }}</a>
				</div>
			}
		}
	</div>
}
@if (ecodePromotion) {
	<div class="product-promotion-container">
		@if (!linkHref()) {
			<common-side-nav class="common-side-nav" [side]="'right'" [isSidePanelToggled]="isSidePanelToggled" [modalName]="heading" tabindex="0">
				<div id="promoPanelHeader" ngProjectAs="myCustomHeader">
					{{ heading }}
				</div>
				<div id="promoPanelBody" ngProjectAs="myCustomBody" [innerHTML]="ecodePromotion.longDesc | dcsgSanitizeHtml" class="hmf-p-md-l hmf-p-s"></div>
				<div [class]="textContainerClassList()" ngProjectAs="myPanelCover">
					<span class="promotion-description-text hmf-subheader-m label-sale">{{ ecodePromotion.pdpDesc }}</span>
				</div>
			</common-side-nav>
		} @else {
			<div [class]="textContainerClassList()">
				<a class="promotion-description-text hmf-subheader-m label-sale" [href]="linkHref()">{{ ecodePromotion.pdpDesc }}</a>
			</div>
		}
	</div>
}
